import * as z from "zod";

const postscriptIntegrationPurpose = ["marketing", "recover"] as const;

export const upsertPostscriptIntegration = {
  name: "upsertPostscriptIntegration" as const,
  input: z.object({
    privateApiKey: z.string(),
    purpose: z.enum(postscriptIntegrationPurpose),
  }),
  output: z.object({ success: z.boolean() }),
};
